var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg001MagicWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.01,
    height: 48,
    viewBox: "0 0 48.01 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-magic-wand",
    "data-name": "001-magic-wand",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80158",
    "data-name": "Path 80158",
    d: "M2.749,31.465,7.07,35.786a2.55,2.55,0,0,0,3.6,0L26.907,19.552l-7.924-7.934L2.749,27.855a2.55,2.55,0,0,0,0,3.61Z",
    transform: "translate(0 13.47)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(26.005 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80159",
    "data-name": "Path 80159",
    d: "M24.259,4.7a2.4,2.4,0,0,1,0,3.394L20.526,11.83a2.4,2.4,0,0,1-3.394-3.394L20.864,4.7a2.4,2.4,0,0,1,3.394,0Z",
    transform: "translate(-5.758 0.801)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80160",
    "data-name": "Path 80160",
    d: "M25.482,10H20.2a2.4,2.4,0,1,0,0,4.8h5.281a2.4,2.4,0,1,0,0-4.8Z",
    transform: "translate(-3.877 9.204)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80161",
    "data-name": "Path 80161",
    d: "M16.8,9.682V4.4a2.4,2.4,0,1,0-4.8,0V9.682a2.4,2.4,0,0,0,4.8,0Z",
    transform: "translate(-12 -2)",
    fill: "#02fdb1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_80162",
    "data-name": "Path 80162",
    d: "M22.831,13.068,18.511,8.747a2.556,2.556,0,0,0-3.6,0l-4.321,4.321,7.938,7.938,4.321-4.321a2.556,2.556,0,0,0-.017-3.618Z",
    transform: "translate(12.029 8.41)",
    fill: "#3bbf83"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001MagicWand);
export default __webpack_public_path__ + "static/media/001-magic-wand.8c9f1efd4bb5bc47edd118a09b1bd113.svg";
export { ForwardRef as ReactComponent };